export interface UtagParam {
  channel: string;
  clubcode: string;
  page: string;
  sessionid: string;
  error?: string;
  subchannel1: string;
  manageautopay?: string;
}

export class UtagHelper {
  static CommonTaggingValues: Partial<UtagParam> = {
    channel: 'my account',
    subchannel1: 'manage auto pay',
  };

  static Errors = {
    systemError: 'system error',
    autoPayError: 'auto pay failed',
    processingError: 'session has timed out',
  };

  static CommonTaggingLine = Object.values(UtagHelper.CommonTaggingValues).join(':');
  static Pages = {
    manageAutoPay: `${UtagHelper.CommonTaggingLine}:manage payments`,
    reviewPayment: `${UtagHelper.CommonTaggingLine}:review payment`,
    reviewPaymentOnUpdate: `${UtagHelper.CommonTaggingLine}:review payment on update`,
    enrollment: `${UtagHelper.CommonTaggingLine}:enrollment`,
    paymentMethod: `${UtagHelper.CommonTaggingLine}:payment method`,
    payment: `${UtagHelper.CommonTaggingLine}:payment`,
    noEmailOnFile: `${UtagHelper.CommonTaggingLine}:no email on file`,
    confirmation: `${UtagHelper.CommonTaggingLine}:confirmation`,
    confirmationError: `${UtagHelper.CommonTaggingLine}:confirmation-error`,
    confirmationReload: `${UtagHelper.CommonTaggingLine}:confirmation-reload`,
    errorCard: `${UtagHelper.CommonTaggingLine}:error-card`,
    errorAutoPay: `${UtagHelper.CommonTaggingLine}:error-auto pay`,
    errorSystem: `${UtagHelper.CommonTaggingLine}:error-system`,
  };

  static loadUtagJs() {
    if ((global as any).utagLoadAttempt) return;
    (global as any).utagLoadAttempt = true;
    const utagJsScript = document.createElement('script');
    utagJsScript.src = '//tms.ace.aaa.com/ace/prod/utag.js';
    utagJsScript.type = 'text/javascript';
    utagJsScript.async = true;
    document.body.appendChild(utagJsScript);
  }

  static tag(tags: UtagParam) {
    (global as any).aceMediaTagValues = { ...tags };
    if (typeof (global as any).utag === 'undefined') {
      this.loadUtagJs();
    } else {
      (global as any).utag.view((global as any).aceMediaTagValues);
    }
  }

  static link(tags: UtagParam) {
    (global as any).aceMediaTagValues = { ...tags };
    if (typeof (global as any).utag === 'undefined') {
      this.loadUtagJs();
    } else {
      (global as any).utag.link((global as any).aceMediaTagValues);
    }
  }
}
